import { ChevronRightIcon } from "@heroicons/react/outline";
import { Link } from "react-router-dom";
import { IProjectGroupWithProjects } from "../../../features/projectGroups/state/projectGroupsSlice";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../common/state/hooks";
import {
  getCurrentProjectGroupElement,
  setSelectedProjectId,
} from "src/features/stats/state/statsSlice";
import {
  closeStandardModal,
  getCurrentModalCurrentState,
} from "src/common/state/slice/modal/modalSlice";
import { getCurrentProject } from "src/features/projects/state/projectsSlice";
import DoubleNavigationItem from "./DoubleNavigationItem";

interface INavigationItem {
  name: string;
  index: any;
  titles: any;
  pathRoute: string[];
  pathnames: string[];
  pathArray: string[];
  pathname: string;
  selectedProjectGroup: IProjectGroupWithProjects;
}

export const NavigationItem = ({
  name,
  index,
  titles,
  pathRoute,
  pathnames,
  pathArray,
  pathname,
  selectedProjectGroup,
}: INavigationItem) => {
  const getModalState = useSelector(getCurrentModalCurrentState);

  const currentProject = useSelector(getCurrentProject);
  const currentProjectGroupElement = useSelector(getCurrentProjectGroupElement);

  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const collaboratorEditMatch = pathname.match(/^\/team\/(\d+)/);
  const participantEditMatch = pathname.match(/^\/learners\/(\d+)/);

  const filterWordNewInpath = pathRoute.filter((word) => word !== "new");
  const routeTo = name === "courses" ? "/courses" : `/${filterWordNewInpath.join("/")}`;

  const isLast = index === pathnames.length - 1;
  const titleCurrentProject = selectedProjectGroup?.name;

  if (!isLast && titles === t("general.projectGroups")) {
    return <></>;
  }

  let link = (
    <span className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-gray-900 md:ml-2">
      {titles}
    </span>
  );

  if (pathArray[0] === "themes" && titles !== t("pages.themeEditor.title")) {
    link = (
      <>
        <button
          onClick={() => {
            dispatch(closeStandardModal("modalThemeEditor"));
          }}
          className="ml-1  text-sm font-medium text-gray-400 md:ml-2"
        >
          {t("pages.themeEditor.title")}
        </button>
        <ChevronRightIcon className="w-5 h-5 text-gray-400" />
        <span className="inline-flex  items-center text-sm font-medium text-gray-700 hover:text-gray-900 md:ml-2">
          {titles}
        </span>
      </>
    );
  }

  //breadcrumb to add Current Project name in the different tabs
  if (
    /(\/courses\/)(\d{1,256}\/)(list\/)(\d{1,256}\/(graph|information|preview|learners))/gm.test(
      pathname,
    )
  ) {
    const routeToEdit = `/courses/${selectedProjectGroup?.id}/list`;

    link = (
      <>
        <Link
          to={routeToEdit}
          className="mr-2 capitalize text-sm font-medium text-gray-400 md:ml-2"
        >
          {selectedProjectGroup.name}
        </Link>
        <ChevronRightIcon className="w-5 h-5 text-gray-400" />
        <span className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-gray-900 md:ml-2">
          {currentProject.name}
        </span>
      </>
    );
  }

  //breadcrumb for edit Current Project name
  if (/(\/courses\/)(\d{1,256}\/)(list\/)(\d{1,256}\/edit)/gm.test(pathname)) {
    const replaceEditforGraph = pathArray;
    replaceEditforGraph[4] = "graph";
    const routeToProjectGroup = `/courses/${selectedProjectGroup?.id}/list`;
    const routeToEdit = name === "courses" ? "/courses" : `/${replaceEditforGraph.join("/")}`;

    link = (
      <>
        <Link to={routeToProjectGroup} className="mr-2 text-sm font-medium text-gray-400 md:ml-2">
          {selectedProjectGroup?.name}
        </Link>
        <ChevronRightIcon className="w-5 h-5 text-gray-400" />
        <Link to={routeToEdit} className="mr-2  text-sm font-medium text-gray-400 md:ml-2">
          {currentProject?.name}
        </Link>
        <ChevronRightIcon className="w-5 h-5 text-gray-400" />
        <span className="inline-flex capitalize items-center text-sm font-medium text-gray-700 hover:text-gray-900 md:ml-2">
          {t("general.edit")}
        </span>
      </>
    );
  }

  // handle templates/:id path to display correct "Templates" link
  if (pathArray[0] === "templates" && pathArray.length >= 2) {
    link = (
      <>
        <Link to={"/templates"} className="ml-1 text-sm font-medium text-gray-400 md:ml-2">
          {t("pages.templates.title")}
        </Link>
        <ChevronRightIcon className="w-5 h-5 text-gray-400" />
        <span className="inline-flex capitalize items-center text-sm font-medium text-gray-700 hover:text-gray-900 md:ml-2">
          {currentProject.name}
        </span>
      </>
    );
  }

  // breadcrumb for userProfile
  if (/(\/profile\/)(\w+)/gm.test(pathname)) {
    const replaceEditforGraph = pathArray;

    switch (pathArray[1]) {
      case "me":
        replaceEditforGraph[1] = t("pages.profile.tabs.myDetails");
        break;
      case "organization":
        replaceEditforGraph[1] = t("pages.profile.tabs.myOrganization");
        break;
      case "subscription":
        replaceEditforGraph[1] = t("pages.profile.tabs.subscription");
        break;
      case "team":
        replaceEditforGraph[1] = t("pages.profile.tabs.team");
        break;
      default:
        pathArray[0];
    }
    link = (
      <>
        <span className="inline-flex  items-center text-sm font-medium text-gray-700 hover:text-gray-900 md:ml-2">
          {pathArray[1]}
        </span>
      </>
    );
  }
  if (
    /(\/courses\/)(\d{1,256}\/)(list\/)(\d{1,256}\/graph)(\/node\/)(\d{1,256})/gm.test(pathname) &&
    getModalState.showStandardModal.show
  ) {
    const replaceEditforGraph = pathArray;

    const routeToEdit = `/${replaceEditforGraph.join("/")}`;
    link = (
      <>
        <Link to={routeToEdit} className="ml-1  text-sm font-medium text-gray-700 md:ml-2">
          {currentProject.name}
        </Link>
        <span className="inline-flex  items-center text-sm font-medium text-gray-700 hover:text-gray-900 md:ml-2"></span>
      </>
    );
  }

  //breadcrumb for edit Projectgroups
  if (/(\/courses\/)(\d{1,256}\/)(edit)/gm.test(pathname)) {
    const replaceEditforGraph = pathArray;
    replaceEditforGraph[2] = "list";

    const routeToEdit = name === "courses" ? "/courses" : `/${replaceEditforGraph.join("/")}`;
    link = (
      <>
        <Link to={routeToEdit} className="mr-2 text-sm font-medium text-gray-400 md:ml-2">
          {titleCurrentProject}
        </Link>
        <ChevronRightIcon className="w-5 h-5 text-gray-400" />
        <span className="inline-flex  items-center text-sm font-medium text-gray-700 hover:text-gray-900 md:ml-2">
          Edit
        </span>
      </>
    );
  }

  if (titles !== t("general.projectGroups") && !isLast) {
    let linkToRoute = routeTo;
    const filterWordTemplate = pathRoute.filter((word) => word !== "template");

    let linkDisplayName =
      name === "courses" ? t("general.projectGroups") : name[0]?.toUpperCase() + name?.slice(1);

    if (linkDisplayName === "Statistics") {
      linkDisplayName = t("sidebar.statistics");
    }
    if (titles === t("pages.statistics.overview")) {
      linkDisplayName = t("sidebar.statistics");
    }
    if (titles === t("pages.profile.myProfile")) {
      linkDisplayName = t("pages.profile.myProfile");
    }
    if (titles === t("pages.faitTemplate.title")) {
      linkToRoute = name === "courses" ? "/courses" : `/${filterWordTemplate.join("/")}`;
    }
    if (/^\/download-client/gm.test(pathname)) {
      linkDisplayName = t("pages.downloadClient.download");
    }

    link = (
      <Link to={linkToRoute} className="ml-1 text-sm font-medium text-gray-400 md:ml-2">
        {linkDisplayName}
      </Link>
    );
    if (linkToRoute === "/statistics") {
      link = (
        <Link
          to={linkToRoute}
          onClick={() => {
            dispatch(setSelectedProjectId(Number(0)));
          }}
          className="ml-1  text-sm font-medium text-gray-400 md:ml-2"
        >
          {linkDisplayName}
        </Link>
      );
    }
  }

  if (pathname.startsWith("/statistics/learners")) {
    if (isLast) {
      return (
        <>
          <li className="inline-flex items-center">
            <ChevronRightIcon className="w-5 h-5 text-gray-400" />
            <Link to="/team" className="text-sm font-medium text-gray-400">
              <span className="inline-flex items-center text-sm font-medium text-gray-400 md:ml-2">
                {t("sidebar.statistics")}
              </span>
            </Link>
          </li>
          <li className="inline-flex items-center">
            <ChevronRightIcon className="w-5 h-5 text-gray-400" />
            <span className="ml-2 text-sm font-medium text-gray-400">
              {currentProjectGroupElement.project_group.name}
            </span>
          </li>
          <li className="inline-flex items-center">
            <ChevronRightIcon className="w-5 h-5 text-gray-400" />
            <span className="ml-2 text-sm font-medium text-gray-700">
              {currentProjectGroupElement.project.name}
            </span>
          </li>
        </>
      );
    }
    return null;
  }

  if (pathname === "/medias") {
    link = (
      <div className="inline-flex  items-center text-sm font-medium text-gray-700 hover:text-gray-900 md:ml-2">
        {t("sidebar.media")}
      </div>
    );
  }

  if (pathname.startsWith("/team/new")) {
    link = (
      <DoubleNavigationItem
        to="/team"
        label={t("pages.project.projectGroupCollaborators.collaborators")}
        action={t("pages.project.projectGroupCollaborators.newCollaborator")}
      />
    );
  } else if (collaboratorEditMatch) {
    link = (
      <DoubleNavigationItem
        to="/team"
        label={t("pages.project.projectGroupCollaborators.collaborators")}
        action={t("pages.collaborators.update")}
      />
    );
  }

  if (pathname.startsWith("/learners/new")) {
    link = (
      <DoubleNavigationItem
        to="/learners"
        label={t("pages.project.projectGroupParticipants.participants")}
        action={t("pages.project.projectGroupParticipants.newParticipant")}
      />
    );
  } else if (participantEditMatch) {
    link = (
      <DoubleNavigationItem
        to="/learners"
        label={t("pages.project.projectGroupParticipants.participants")}
        action={t("pages.participants.update")}
      />
    );
  }

  if (
    (pathname.startsWith("/team") && name === "collaborators") ||
    (pathname.startsWith("/learners") && name === "participants")
  ) {
    if (isLast) {
      return (
        <li className="inline-flex items-center">
          <ChevronRightIcon className="w-5 h-5 mr-1 text-gray-400" />
          <span className="ml-1 text-sm font-medium text-gray-700">
            {t(`pages.project.projectGroup${name.charAt(0).toUpperCase() + name.slice(1)}.${name}`)}
          </span>
        </li>
      );
    }
    return null;
  }

  // to avoid double items in the breadcrumb for team
  if (pathname.startsWith("/team") && name === "team") {
    if (isLast) {
      return (
        <li className="inline-flex items-center">
          <ChevronRightIcon className="w-5 h-5 mr-1 text-gray-400" />
          <span className="ml-1 text-sm font-medium text-gray-700">
            {t("pages.project.projectGroupCollaborators.collaborators")}
          </span>
        </li>
      );
    }
    return null;
  }
  if (pathname.startsWith("/team/new")) {
    if (isLast) {
      return (
        <>
          <li className="inline-flex items-center">
            <ChevronRightIcon className="w-5 h-5 text-gray-400" />
            <Link to="/team" className="text-sm font-medium text-gray-400">
              <span className="inline-flex items-center text-sm font-medium text-gray-400 md:ml-2">
                {t("pages.project.projectGroupCollaborators.collaborators")}
              </span>
            </Link>
          </li>
          <li className="inline-flex items-center">
            <ChevronRightIcon className="w-5 h-5 text-gray-400" />
            <span className="ml-2 text-sm font-medium text-gray-700">
              {t("pages.project.projectGroupCollaborators.newCollaborator")}
            </span>
          </li>
        </>
      );
    }
    return null;
  }

  // to avoid double items in the breadcrumb for learners
  if (pathname.startsWith("/learners") && name === "learners") {
    if (isLast) {
      return (
        <li className="inline-flex items-center">
          <ChevronRightIcon className="w-5 h-5 mr-1 text-gray-400" />
          <span className="ml-1 text-sm font-medium text-gray-700">
            {t("pages.project.projectGroupParticipants.participants")}
          </span>
        </li>
      );
    }
    return null;
  }

  // to avoid double items in the breadcrumb for new learners
  if (pathname.startsWith("/learners/new/invite")) {
    if (isLast) {
      return (
        <>
          <li className="inline-flex items-center">
            <ChevronRightIcon className="w-5 h-5 text-gray-400" />
            <Link to="/learners" className="text-sm font-medium text-gray-400">
              <span className="inline-flex items-center text-sm font-medium text-gray-400 md:ml-2">
                {t("pages.project.projectGroupParticipants.participants")}
              </span>
            </Link>
          </li>
          <li className="inline-flex items-center">
            <ChevronRightIcon className="w-5 h-5 text-gray-400" />
            <span className="ml-2 text-sm font-medium text-gray-700">
              {t("pages.project.projectGroupParticipants.newParticipant")}
            </span>
          </li>
        </>
      );
    }
    return null;
  }

  return (
    <li>
      <div className="flex items-center">
        <ChevronRightIcon className="w-5 h-5 text-gray-400" />
        {link}
      </div>
    </li>
  );
};

export default NavigationItem;
